import { CircularProgress, CircularProgressProps } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';

import { useStyles } from 'features/app/components/SmallSpinner/styles';

interface SmallSpinnerProps extends CircularProgressProps {
  show?: boolean;
  pad?: 'left' | 'right';
}

export const SmallSpinner: React.FC<SmallSpinnerProps> = ({ show, pad = 'right', ...rest }) => {
  const classes = useStyles();

  return show ? <CircularProgress size={10} className={clsx(classes.spinner, classes[pad])} {...rest} /> : null;
};
